/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from 'react';
import ChevronDown from 'ui/components/icons/ChevronDown';
import { RangeSlider } from 'ui';
import { Typography } from 'ui';
import { CalculationTypes } from 'src/modules/newCars/constants/model';
import { VariantsListType } from 'src/modules/newCars/types';
import { ButtonVariants, Color, TypeScales } from 'ui/primitives';
import { Modal } from 'ui';
import { Button } from 'ui';
import CarRefuelIcon from '../../../../icons/CarRefuel.svg';
import s from './CalculatedValues.module.scss';

export const CalculatedValues = ({
  type,
  variantList,
  brandName,
  modelName,
}: {
  type: CalculationTypes;
  variantList: VariantsListType[];
  brandName: string;
  modelName: string;
}) => {
  const [runningCost, setRunningCost] = useState(0);
  const [resaleValue, setResaleValue] = useState(1);
  const [showList, setShowList] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(variantList?.[1]);
  const [runningSliderVal, setRunningSliderVal] = useState(10);

  function calculateRunningCost(val) {
    setRunningSliderVal(val);
    const mileage = +selectedVariant?.mileageInNumbers;
    if (!mileage) {
      return;
    }
    const formulaValue = (val / Number(mileage)) * 300;
    setRunningCost(Math.round(formulaValue * 10));
  }

  useEffect(() => {
    calculateRunningCost(runningSliderVal);
  }, [selectedVariant]);

  return (
    <div className={s.container}>
      <div className={s.root}>
        <Typography
          label={
            type === CalculationTypes.resaleValue
              ? 'MG Hector resale value'
              : `${brandName} ${modelName} running cost`
          }
          variant="h2"
        />
        <button
          type="button"
          className={s.btn}
          onClick={() => setShowList(true)}
        >
          <Typography
            label={
              selectedVariant ? selectedVariant?.variantName : 'Choose variants'
            }
            variant="base_big_sb"
            renderAs="SPAN"
          />
          <ChevronDown />
        </button>
        <Typography
          label={
            type === CalculationTypes.runningCost
              ? 'KM driven per day'
              : 'Select no of years'
          }
          variant={TypeScales.base_big_m}
        />
        <div className={s.slider}>
          {type === CalculationTypes.resaleValue ? (
            <RangeSlider
              value={resaleValue}
              onChange={(val) => setResaleValue(val)}
              min={1}
              minLabel="1"
              maxLabel="7"
              step={1}
              max={7}
              showLabel
            />
          ) : (
            <RangeSlider
              value={runningSliderVal}
              // eslint-disable-next-line react/jsx-no-bind
              onChange={calculateRunningCost}
              min={10}
              minLabel="10"
              maxLabel="150"
              step={10}
              max={150}
              showLabel
            />
          )}
        </div>
        <Typography
          label="Monthly running cost"
          variant={TypeScales.body_para_r}
          style={{ marginBottom: '12px' }}
          color={Color.text_subheading}
        />
        <Typography label={`₹${runningCost}/ month`} variant={TypeScales.h3} />
      </div>
      <div className={s.car_bg}>
        <CarRefuelIcon />
      </div>
      {showList && (
        <Modal
          show={showList}
          isWeb
          head={{
            show: true,
            title: 'Choose variant',
            onClose: () => setShowList(false),
          }}
          closeOnClickOutside
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="bottomSheet"
          rootStyle={{ zIndex: 1 }}
        >
          {variantList?.map((obj: VariantsListType) => (
            <Button
              key={obj?.variantName}
              variant={selectedVariant === obj ? ButtonVariants.PrimaryNaked : ButtonVariants.BlackNaked}
              label={obj?.variantName}
              onClick={() => {
                setSelectedVariant(obj);
                setShowList(false);
              }}
            />
          ))}
        </Modal>
      )}
    </div>
  );
};
